import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AdvancedSearchState {
    // Map of entity type (lowercase) to SCIM filter string
    filters: Record<string, string>;
}

const initialState: AdvancedSearchState = {
    filters: {}
};

const advancedSearchSlice = createSlice({
    name: 'advancedSearch',
    initialState,
    reducers: {
        setFilter: (state, action: PayloadAction<{ entityType: string; filter: string }>) => {
            const entityType = action.payload.entityType.toLowerCase();
            if (action.payload.filter.trim()) {
                state.filters[entityType] = action.payload.filter;
            } else {
                // Remove empty filters
                delete state.filters[entityType];
            }
        },
        clearFilter: (state, action: PayloadAction<string>) => {
            const entityType = action.payload.toLowerCase();
            delete state.filters[entityType];
        },
        clearAllFilters: (state) => {
            state.filters = {};
        }
    }
});

export const { setFilter, clearFilter, clearAllFilters } = advancedSearchSlice.actions;
export default advancedSearchSlice.reducer;

